/**
 * index.js.js
 *
 * @Author: zhangce
 * @Date: 18/1/23 下午2:44
 */
import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

Breadcrumb.Item = BreadcrumbItem;

export { BreadcrumbItem };
export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/breadcrumb/index.js